export const obtenerFechaLocal = ({clave, fecha}) => {


    let claveFecha = 'fecha' + clave

    let res = localStorage.getItem(claveFecha)

    if (!res) {
        return 0
    }

    return parseInt(res)


}